import {
    IMarketingCompensatedDiscountsDTO,
    IMarketingCompensatedDiscountsProductsDTO,
    IMarketingCompensatedDiscountsProductsViewDTO,
    IMarketingCompensatedDiscountsViewDTO    
    } from "../../coreapi-dto/dirs/marketingCompensatedDiscounts";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "./baseDirRequest";


interface IMarketingCompensatedDiscountsCreate extends IMarketingCompensatedDiscountsDTO {
}
interface IMarketingCompensatedDiscountsUpdate extends IMarketingCompensatedDiscountsDTO {
}

interface IMarketingCompensatedDiscountsProductsCreate extends IMarketingCompensatedDiscountsProductsDTO {
}
interface IMarketingCompensatedDiscountsProductsUpdate extends IMarketingCompensatedDiscountsProductsDTO {
}

class MarketingCompensatedDiscountsRequest extends BaseDirRequest<IMarketingCompensatedDiscountsViewDTO, IMarketingCompensatedDiscountsDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ProAptekaMarketingCompensatedDiscount", token, eventHandler)
    }
    
    create(body: IMarketingCompensatedDiscountsCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IMarketingCompensatedDiscountsUpdate, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }

    getViewParam(body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IMarketingCompensatedDiscountsViewDTO>>) => void, report?: (value) => void) {
        this.post<IViewWrapper<IMarketingCompensatedDiscountsViewDTO>>(`${this._baseUrl}/${this._routePrefix}/ViewParam`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                } else {
                    callback?.(e);
                    report?.({ name: `${this._routePrefix}/ViewParam`, time: e.time })
                }
            }


        })
    }
}

class MarketingCompensatedDiscountsProductsRequest extends BaseDirRequest<IMarketingCompensatedDiscountsProductsViewDTO, IMarketingCompensatedDiscountsProductsDTO> {

    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ProAptekaMarketingCompensatedDiscountProduct", token, eventHandler)
    }
    
    create(body: IMarketingCompensatedDiscountsProductsCreate, callback: (e:CoreApiResponse<string>) => void) {
        super.create(body, callback)
    }

    update(idGlobal: string, body: IMarketingCompensatedDiscountsProductsUpdate, callback: (e:CoreApiResponse<null>) => void) {
        super.update(idGlobal, body, callback)
    }

    getViewParam(body: IViewBody, callback?: (e: CoreApiResponse<IViewWrapper<IMarketingCompensatedDiscountsProductsViewDTO>>) => void, report?: (value) => void) {
        this.post<IViewWrapper<IMarketingCompensatedDiscountsProductsViewDTO>>(`${this._baseUrl}/${this._routePrefix}/ViewParam`, body, this.concatHeaders([this.getBearerHeader(this._token)], [ContentType.ApplicationJson]), (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                } else {
                    callback?.(e);
                    report?.({ name: `${this._routePrefix}/ViewParam`, time: e.time })
                }
            }


        })
    }
}

export {
    MarketingCompensatedDiscountsRequest,
    MarketingCompensatedDiscountsProductsRequest    
};